import React, { useEffect, useRef, useState } from 'react'
import ErrorInnerPopup from '../../../Popups/ErrorInnerPopup';
import ErrorPopup from '../../../Popups/ErrorPopup';
import { formatPrice } from "../../../NumberFormat";
import ColakBebasUpdatePopup from '../../../Popups/ColakBebasUpdatePopup';
import { withTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { dotNumberBlurValidation, dotNumberValidation, makeAjax, respStatus, showMessage, url, withDotValidation } from '../../../../helpers/global_helper';
import ConfirmBetDeskonPopup from '../../../Popups/ConfirmBetDeskonPopup';
import BetSuccessPopup from '../../../Popups/BetSuccessPopup';
import CancelledBetDeskonPopup from '../../../Popups/CancelledBetDeskonPopup';
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from '../GameClosedPopup';
import MarketClose from '../MarketClose';
import CommonBetHeader from '../CommonBetHeader';

const ColokBebas = (props) => {
  const dispatch = useDispatch();
  const device = useSelector(state => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [rowsToShow, setRowsToShow] = useState(10);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [beliDisabled, setBeliDisabled] = useState(Array(rowsToShow).fill(true));
  const [bets, setBets] = useState({});
  const [belli, setBbelli] = useState({});
  const [diskon, setDiskon] = useState({});
  const [bolakBalik, setBolakBalik] = useState({});
  const [errorMessages, setErrorMessages] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [respData, setRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false)
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [focusIndex, setFocusIndex] = useState(null);
  const beliRefs = useRef(Array(rowsToShow).fill(null));
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [defaultValue, setDefaultvalue] = useState("");
  const [totals, setTotals] = useState([]);
  const [betValues, setBetValues] = useState(Array(rowsToShow).fill(''));
  const [discountValues, setDiscountValues] = useState(Array(rowsToShow).fill(''));
  const [payValues, setPayValues] = useState(Array(rowsToShow).fill(''));
  const [totalBetAmount, setTotalBetAmount] = useState()
  const [discountPrize, setPrizeDiscount] = useState([]);
  const [autoBetValue, setAutoBetValue] = useState('');

  const handleDeafultAutobet = (e) => {
    const value = e.target.value;
    const regex = /^\d*([.,]\d?)?$/;
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  const handleAutoBet = (value) => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setAutoBetValue(value);
    }
  }

  const handleAutoBetBlur = (value) => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setAutoBetValue(value);
    }
  }

  const handleBetInputFocus = (index) => {
    if (betValues[index] === '') {
      setBetValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index] = autoBetValue;
        handleInputChange(index, autoBetValue);
        return newValues;
      });
    }
  };


  const [reqData, setReqData] = useState({
    isfullbet: null,
    gameId: null,
    // gameId:gameId,
    gameType: "colokbebas",
    action: "process",
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
    dataangka: []
  });

  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameId, "gameType": gameType }).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setPrizeDiscount(response.data);
    })
  }, [gameId, gameType])

  // Calculate total of all pay columns and send it to CommonBetHeader
  useEffect(() => {
    const totalFinalAmount = payValues.reduce((total, payVal) => {
      const currentPay = parseFloat(payVal) || 0;
      return total + currentPay;
    }, 0);

    setTotalBetAmount(totalFinalAmount);
  }, [payValues]);

  let dicountValue = 1000;

  const handleInputBlur = (index, value) => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    
    handleInputChange(index, value);
  }

  const handleInputChange = (index, value) => {
    let newInputs = [...betValues];
    let newErrorMessages = [];
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    setBetValues(value); // Update the second input value when typed

    if (value === '') {
      newInputs[index] = '';
      setDiscountValues((prevValues) => {
        const updatedDiscountValues = [...prevValues];
        updatedDiscountValues[index] = '';
        return updatedDiscountValues;
      });
      setPayValues((prevValues) => {
        const updatedPayValues = [...prevValues];
        updatedPayValues[index] = '';
        return updatedPayValues;
      });
      setBetValues(newInputs);
      return;
    }

    const betValue = parseFloat(value);
    const baseMultiplier = betDiscount.showMultiple;
    const discountRate = betDiscount.showDisc / 100;

    if (regex.test(value)) {
      if (isNaN(value)) {
        value = "";
        return;
      }
      if (betValue <= (betDiscount.showMax / 1000)) {
        // Valid value
        newInputs[index] = value;
        setBetValues(newInputs);
        // Calculate discount and pay
        const discount = betValue * baseMultiplier * discountRate;
        const pay = betValue * baseMultiplier - discount;

        setDiscountValues((prevValues) => {
          const updatedDiscountValues = [...prevValues];
          updatedDiscountValues[index] = discount;
          return updatedDiscountValues;
        });

        setPayValues((prevValues) => {
          const updatedPayValues = [...prevValues];
          updatedPayValues[index] = pay;
          return updatedPayValues;
        });
      }
      else {
        // Handle out of range for maximum bet value
        newInputs[index] = '';
        setDiscountValues((prevValues) => {
          const updatedDiscountValues = [...prevValues];
          updatedDiscountValues[index] = ''; // Clear discount
          return updatedDiscountValues;
        });
        setPayValues((prevValues) => {
          const updatedPayValues = [...prevValues];
          updatedPayValues[index] = ''; // Clear pay
          return updatedPayValues;
        });

        // Only show max bet error message
        newErrorMessages.push(props.t('you_have_reached_max_bet_value'));
      }
    }
    else {
      // newInputs[index] = '';
      // setDiscountValues((prevValues) => {
      //   const updatedDiscountValues = [...prevValues];
      //   updatedDiscountValues[index] = ''; // Clear discount
      //   return updatedDiscountValues;
      // });
      // setPayValues((prevValues) => {
      //   const updatedPayValues = [...prevValues];
      //   updatedPayValues[index] = ''; // Clear pay
      //   return updatedPayValues;
      // });
      // newErrorMessages.push(props.t('invalid_input_please_enter_a_number'));
    }

    setBetValues(newInputs);
    setErrorMessages(newErrorMessages);
    setShowErrorPopup(newErrorMessages.length > 0);
  };


  const confirmBet = () => {
    let betFinalValues;

    // if (device === "Desktop") {
    //   betFinalValues = betValues
    //     .map((value, index) => [index, value * 1000]) // Create array of [index, value] pairs
    //     .filter(([, value]) => value !== '' && value > 0);
    // } else {
    //   const isValid = (items) => {
    //     return items !== null && items !== "" && items !== undefined
    //   }
    //   betFinalValues = Object.keys(bets)
    //     .filter(val => isValid(bets[val]) && isValid(belli[val])) // Filter out indices where bets or belli are empty
    //     .map(item => [bets[item], parseInt(belli[item]) * 1000, "success"]); // Create array of [bets, belli * 1000, "success"] pairs
    // }
    betFinalValues = betValues
      .map((value, index) => [index, value * betDiscount.showMultiple]) // Create array of [index, value] pairs
      .filter(([, value]) => value !== '' && value > 0);

    const newReqData = {
      ...reqData,
      gameId: gameId,
      dataangka: betFinalValues
    };

    setReqData(newReqData);

    if (betFinalValues.length > 0) {
      setShowConfirmationPopup(true);
      return
    } else {
      setErrorMessages([props.t('guess_bet_wrong')]);
      setShowErrorPopup(true);
    }

  }

  useEffect(() => {
    resetBetData()
  }, [gameId])


  const resetBetData = () => {
    setReqData({
      isfullbet: null,
      gameId: null,
      gameType: "colokbebas",
      action: "process",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dataangka: []
    });

    setAutoBetValue('')
    setDiscountValues(Array(rowsToShow).fill(''));
    setPayValues(Array(rowsToShow).fill(''));
    setErrorMessages([]);
    setBetValues(Array(rowsToShow).fill(''));
    setBeliDisabled(Array(rowsToShow).fill(true));
    setShowErrorPopup(false);
    setBbelli([])
    setBets("")
    setDiskon("")
    setBolakBalik("")
    setDefaultvalue("")
    setTotals([]);
    setTotalBetAmount(0);  // reset totalBetAmount  
  }
  const rowDataReset = (rowIndex) => {
    setBets((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });
    setBbelli((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });

    setDiskon((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });

    setBolakBalik((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });
    const newBeliDisabled = [...beliDisabled];
    newBeliDisabled[rowIndex] = true;
    setBeliDisabled(newBeliDisabled);
  };
  const handleClose = () => {
    setRespData([]);
    setSuccessPopup(false);
    setRespData([]);
  }
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);

    makeAjax(
      url.TOGEL_API.processAltTogel, reqData).then(response => {
        if (response.status !== respStatus['SUCCESS']) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
          if (response.code !== "validation_error") {
            setErrorMessages(props.t(response.code));
            setShowErrorPopup(true);
            return;
          }
          showMessage(response)
          return;
        }
        setRespData(prevArray => [...prevArray, response.data]);
        dispatch(getUserBalance());
        setSuccessPopup(true);
        // setShowConfirmationPopup(false);
        resetBetData();
        setReqData({
          isfullbet: null,
          gameId: null,
          gameType: "colokbebas",
          action: "process",
          betTogelAuth: "betTogelAuth",
          allowPartner: "allowPartner",
          dataangka: []
        });
      });
  }
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true)
  }

  // const handleInputBetsChange = (e, rowIndex) => {
  //   const { name, value } = e.target;
  //   const onlyNumbers = value.replace(/[^0-9]/g, '');

  //   if (onlyNumbers.length === 1) {
  //     // Move focus to the next input field if there is one
  //     const nextInput = document.querySelector(`input[name="bet-${rowIndex + 1}"]`);
  //     if (nextInput) {
  //       nextInput.focus();
  //     }
  //   }

  //   const newbets = {
  //     ...bets,
  //     [rowIndex]: onlyNumbers
  //   };
  //   setBets(newbets);

  //   const newBeliDisabled = [...beliDisabled];
  //   newBeliDisabled[rowIndex] = !onlyNumbers;
  //   setBeliDisabled(newBeliDisabled);

  //   setFocusIndex(rowIndex);
  // }
  const handleInputBetsChange = (e, rowIndex) => {
    const { value } = e.target;
    const onlyNumbers = value.replace(/[^0-9]/g, '');
    const newbets = {
      ...bets,
      [rowIndex]: onlyNumbers
    };
    setBets(newbets);
    const newBeliDisabled = [...beliDisabled];
    newBeliDisabled[rowIndex] = !onlyNumbers;
    setBeliDisabled(newBeliDisabled);
    if (onlyNumbers === '') {
      setBbelli((prev) => {
        const updated = { ...prev };
        delete updated[rowIndex];
        return updated;
      });
      setDiskon((prev) => {
        const updated = { ...prev };
        delete updated[rowIndex];
        return updated;
      });
      setBolakBalik((prev) => {
        const updated = { ...prev };
        delete updated[rowIndex];
        return updated;
      });
    }
    setFocusIndex(rowIndex);
  }

  const handleInputFocusBelli = (e, rowIndex) => {
    const { name, value } = e.target;
    if (defaultValue !== "" && defaultValue !== undefined) {
      setBbelli((prevBelli) => ({
        ...prevBelli,
        [rowIndex]: defaultValue,
      }));
      setBets({
        ...bets,
        [`${name}`]: rowIndex
      })
      let newDiskon = (defaultValue * betDiscount.showDisc * dicountValue) / 100;
      let newBolakBalik = defaultValue * dicountValue - newDiskon;
      // calculateTotal(defaultValue);
      setTotals((previous) => {
        const updateTotal = [...previous]
        updateTotal[rowIndex] = newBolakBalik
        return updateTotal
      });
    }
  }
  const handleInputChangeBelli = (e, rowIndex) => {
    const newValues = e.target.value;
    let value = newValues ? newValues : "";
    let newDiskon = 0;
    let newBolakBalik = 0;
    const minAllowedValue = betDiscount.showMin / 1000;
    const maxAllowedValue = betDiscount.showMax / 1000;
    const numericValue = parseFloat(value);
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      if (numericValue < minAllowedValue || numericValue > maxAllowedValue) {
        let errorMessage;
        // if (numericValue < minAllowedValue) {
        //   errorMessage = props.t("minimum_bet_is_") + ` ${minAllowedValue}`;
        // } else 
        if (numericValue > maxAllowedValue) {
          errorMessage = props.t('you_have_reached_max_bet_value');
        }
        setErrorMessages([errorMessage]);
        setShowErrorPopup(true);
        return;
      }
      if (value) {
        newDiskon = (numericValue * betDiscount.showDisc * dicountValue) / 100;
        newBolakBalik = numericValue * dicountValue - newDiskon;
      }
      setBbelli((prevBelli) => ({
        ...prevBelli,
        [rowIndex]: value,
      }));
      setBolakBalik((prevBolakBalik) => ({
        ...prevBolakBalik,
        [rowIndex]: newBolakBalik,
      }));
      setDiskon((prevDiskon) => ({
        ...prevDiskon,
        [rowIndex]: newDiskon,
      }));
      setBets({
        ...bets,
        [rowIndex]: rowIndex
      })


      // setPayValues((prevValues) => {
      //   const updatedPayValues = [...prevValues];
      //   updatedPayValues[index] = pay;
      //   return updatedPayValues;
      // });

      setTotals((previous) => {
        const updateTotal = [...previous]
        updateTotal[rowIndex] = newBolakBalik
        return updateTotal
      });
    }
  };
  useEffect(() => {
    if (focusIndex !== null) {
      beliRefs.current[focusIndex].focus();
      setFocusIndex(null);
    }
  }, [focusIndex, beliDisabled]);
  return (
    <div className='colokbebas_wrapper'>
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {
            device === "Desktop" ?

              <div className="colokbebas_container">
                <div>
                  <CommonBetHeader gameName={"colokBebas"} totalBetAmount={totalBetAmount} rowsToShow={null} />
                </div>
                <table>
                  <thead>
                    <tr className="Heading">
                      <th>{props.t('guess')}</th>
                      <th >
                        <input
                          type="text"
                          placeholder="Auto Bet"
                          value={autoBetValue}
                          onChange={(e) => handleAutoBet(e.target.value)}
                          onBlur={(e) => handleAutoBetBlur(e.target.value)}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </th>
                      <th>{props.t("discount")}</th>
                      <th>{props.t("pay")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(rowsToShow)].map((_, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                        <td>{index}</td>
                        <td className="inputs">
                          <input
                            type="text"
                            placeholder="Bet"
                            value={betValues[index]}
                            onFocus={() => handleBetInputFocus(index)} // Automatically set value when clicked
                            onChange={(e) => handleInputChange(index, e.target.value)}
                            onBlur={(e) => handleInputBlur(index, e.target.value)}
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]**"
                          />
                        </td>
                        <td className="inputs">
                          <input
                            name={index}
                            type="text"
                            disabled={betValues[index] ? false : true}
                            value={formatPrice(discountValues[index])}
                            readOnly

                          />
                        </td>
                        <td className="inputs">
                          <input
                            name={index}
                            type="text"
                            disabled={betValues[index] ? false : true}
                            value={formatPrice(payValues[index])}
                            readOnly
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              :
              <div className='colokbebas_container_mobile'>
                <div className='container'>
                  {/* <CommonBetHeader gameName={"colokBebas"} totalBetAmount={totalBetAmount} rowsToShow={null} /> */}
                  <CommonBetHeader gameName={"colokBebas"} totalBetAmount={totalBetAmount} rowsToShow={null} />

                  {/* <table>
                    <thead>
                      <tr >
                        <th style={{ whiteSpace: "nowrap", textAlign: "center", paddingRight: 5, }} colSpan={2}>
                          {props.t("Nominal Bet IDR 1 = 1000")}
                        </th>
                        <th className="total_pay link2" style={{ whiteSpace: "nowrap", textAlign: "right", paddingRight: 5 }} colSpan={3}>
                          {props.t("total")} {props.t("Bet")}:
                          <span className="betdiskon_total_discount" >
                            {formatPrice(totals.filter(amount => amount !== undefined).reduce((accumulator, currentValue) => accumulator + currentValue, 0))}
                          </span>
                        </th>
                      </tr>
                    </thead>
                  </table> */}
                  <table>
                    <thead>
                      <tr>
                        {/* <th>{props.t('no.')}</th> */}
                        <th style={{ width: "50%" }}>{props.t('guess')}</th>
                        {/* <th>{props.t('buy')}<span className='small_input'>1=1000</span></th> */}
                        <th>
                          <input
                            type="text"
                            autoComplete="off"
                            placeholder="Auto Bet"
                            // value={defaultValue}
                            // onChange={(e) => handleDeafultAutobet(e)}
                            value={autoBetValue}
                            onChange={(e) => handleAutoBet(e.target.value)}
                            onBlur={(e) => handleAutoBetBlur(e.target.value)}
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]**"
                          />
                        </th >
                        {/* <th>{props.t('discount')}</th>
                        <th>{props.t('pay')}</th> */}
                        {/* <th></th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(rowsToShow)].map((_, index) => (
                        <tr key={index + 1} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                          <td >{index}</td>
                          {/* <td><input type='text'
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength="1"
                            name={`bets${index}`}
                            value={(bets[index] ? bets[index] : "")}
                            onChange={(e) => handleInputBetsChange(e, index)}
                            autocomplete="off"
                          /></td> */}
                          <td><input type='text'
                            maxlength="100"
                            placeholder='Bet'
                            name={`${index}`}

                            // value={(belli)[index] ? (belli)[index] : ''}
                            // onChange={(e) => handleInputChangeBelli(e, index)}
                            // onFocus={(e) => handleInputFocusBelli(e, index)}         

                            // ref={el => beliRefs.current[index] = el}
                            value={betValues[index]}
                            onFocus={() => handleBetInputFocus(index)} // Automatically set value when clicked
                            onChange={(e) => handleInputChange(index, e.target.value)}
                            onBlur={(e) => handleInputBlur(index, e.target.value)}
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]**"
                            autocomplete="off"
                          /></td>

                          {/* <td><input type='text' name={index}
                            readOnly tabindex="-1"
                            value={(diskon)[index] ? (diskon)[index] : ''}

                          /></td>
                          <td><input
                            name={index} readOnly tabindex="-1"
                            type="text" value={(bolakBalik)[index] ? (bolakBalik)[index] : ''}
                          /></td> */}
                          {/* <td><button
                            onClick={(e) => rowDataReset(index)} tabindex="-1"
                            className='reset-button'>reset</button></td> */}
                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>

              </div>
          }

          <div className="last_div">
            <div className="left_div">
              <p> {props.t('guess_one_4d')}</p>
              {/* <p>Menebak bebas 1 angka dari 4D.</p> */}
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={resetBetData}>{props.t('reset')}</button>
                </li>
                <li>
                  <button className="submit" onClick={confirmBet}>{props.t('submit')}</button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup message={errorMessages} onClose={() => setShowErrorPopup(false)} />
        </ErrorInnerPopup>
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose} submitProcessOk={submitProcessOk}

        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup
          onClose={() => setShowCanclledPopup(false)}

        />
      )}
      {successPopup && (
        <div className="popup-overlay ">
          <BetSuccessPopup response={respData} onClose={() => handleClose()} />
        </div>
      )}
    </div>
  );
}

export default withTranslation()(ColokBebas);
